import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Paginated } from '@next/core-lib/models';
import { Observable } from 'rxjs';

import { PageAndSize, ReturnableInvoiceLine } from '../models/returnable-invoiceline.model';

@Injectable({
  providedIn: 'root',
})
export class ReturnableInvoiceService {
  protected baseUrl = `${this.env.API_BASE_URL}/service/order-aggregation/secure`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private env: AgrEnvironment,
  ) {}

  public getReturnableInvoiceLinesPaginated(
    pagination: PageAndSize,
    externalInvoiceId?: string,
    searchTerm?: string,
  ): Observable<Paginated<ReturnableInvoiceLine>> {
    const url = externalInvoiceId ? `${this.baseUrl}/returnableinvoicelines/${externalInvoiceId}` : `${this.baseUrl}/returnableinvoicelines`;

    let params = new HttpParams({ fromObject: pagination });

    if (searchTerm) {
      params = params.append('searchTerm', searchTerm);
    }

    return this.http.get<Paginated<ReturnableInvoiceLine>>(url, { params });
  }
}
